<template>
  <div class="row">
    <div class="form-group col-6">
      <label class="control-label" for="assistant_type">Assistant Type</label>
      <select id="assistant_type" v-model="assistantType" :disabled="disabletype" class="form-control"
              name="type">
        <option value="feedback">Feedback</option>
        <option value="scoring">Scoring</option>
        <option value="meta">Meta</option>
      </select>
    </div>
    <div v-if="files && files.length > 0" class="col-12 mt-4">
      <label class="control-label">Attached Files</label>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Name</th>
          <th>Ext</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="file in files">
          <td>{{ file.filename }}</td>
          <td>{{ file.extension }}</td>
          <td>
            <button class="btn btn-danger" type="button" @click="removeFile(file)"><span
                class="sr-only">Remove File</span><i class="fas fa-trash"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="id" class="col-12 mt-4">
      <file-pond
          ref="pond"
          :server="pondServer"
          accepted-file-types="application/pdf, text/plain, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          label-idle="Drop files here or <span class='filepond--label-action'>Browse</span>"
          name="file"
          v-bind:allow-multiple="false"
          @processfile="handleFileSuccess"
          @processfileerror="handleFileFailure"
      />
    </div>
  </div>
</template>

<script>

import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

const FilePond = vueFilePond(FilePondPluginFileValidateType)

export default {
  props: ['id', 'filesp', 'typep', 'disabletype', 'documentretrievalEnabled'],
  components: {
    FilePond
  },
  data() {
    return {
      assistantType: this.typep || 'feedback',
      enableDocumentRetrieval: this.documentretrievalEnabled || false,
      files: this.filesp || [],
      pondServer: {
        process: {
          url: `/assistants/${this.id}/upload`,
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          }
        }
      }
    }
  },
  methods: {
    change(checked, meter) {
      if (!checked) {
        let num = parseInt(meter.split('-')[1])
        // remove all meters after the meter that was unchecked
        this.meters = this.meters.filter(m => {
          let mNum = parseInt(m.split('-')[1])
          return mNum < num
        })
      }
    },
    handleFileSuccess(error, response) {
      if (error) {
        console.error('Failed to upload file', error)
        return
      }
      console.log(error)
      console.log('File uploaded')
      console.log(JSON.parse(response.serverId))

      let resp = JSON.parse(response.serverId)
      this.files.push({
        filename: resp.filename,
        extension: resp.extension
      })
    },
    handleFileFailure(error, file) {
      console.error('Failed to upload file', error)
    },
    removeFile: async function (file) {
      let url = `/assistants/${this.id}/file/${file.openAiFileId}`
      let resp = await axios.delete(url)
      this.files = this.files.filter(f => f.filename !== file.filename)
    }
  }
}
</script>
